import React, { useEffect, useState } from 'react';
import api from '../../../../config/axios';

import BancoModal from './modals/Banco';
import Paginacao from '../../../../components/utils/paginacao';

import { FaPlus, FaEdit, FaFilter, FaTrashAlt, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Bancos = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const [bancos, setBancos] = useState([]);
  const [filtroCodigo, setFiltroCodigo] = useState('');
  const [filtroNome, setFiltroNome] = useState('');

  const [selectedBanco, setSelectedBanco] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchBancos = async (currentPage) => {
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const params = {
        page: currentPage,
        limit: limit,
        codigo: filtroCodigo,
        nome: filtroNome
      };

      const response = await api.get('/bancos', { params });

      setBancos(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar os dados. Tente novamente mais tarde.');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchBancos(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddBanco = () => {
    setSelectedBanco(null);
    setIsModalOpen(true);
  };

  const handleEditBanco = (banco) => {
    setSelectedBanco(banco);
    setIsModalOpen(true);
  };

  const handleDeleteBanco = async (banco) => {
    const result = await Swal.fire({
      title: 'Tem certeza?',
      text: `Deseja excluir o banco "${banco.nome}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir!',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/bancos/${banco.id}`);
        Swal.fire('Excluído!', 'Banco foi excluído com sucesso.', 'success');
        fetchBancos(currentPage);
      } catch (error) {
        Swal.fire('Erro!', error.response.data.message || 'Não foi possível excluir o banco.', 'error');
      }
    }
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchBancos(1);
  };

  const handleLimparFiltros = () => {
    setFiltroCodigo('');
    setFiltroNome('');
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedBanco(null);
  };

  const handleBancoAtualizado = () => {
    fetchBancos(currentPage);
    handleModalClose();
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-outline-secondary me-3"
                  onClick={() => navigate('/financeiro/cadastros')}
                  title="Voltar para Cadastros"
                >
                  <FaArrowLeft />
                </button>
                <h4 className="fw-bold mb-0">Bancos</h4>
              </div>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddBanco}>
                <FaPlus /> Adicionar Banco
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-3 col-12">
              <label className="form-label fw-bold">Código</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o código do banco"
                value={filtroCodigo}
                className="form-control"
                onChange={(e) => setFiltroCodigo(e.target.value)}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">Nome</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o nome do banco"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-6 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th>Código</th>
                    <th className="text-nowrap">Nome</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {bancos.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="text-center">
                        Nenhum banco encontrado.
                      </td>
                    </tr>
                  ) : (
                    bancos.map((banco, index) => (
                      <tr key={index}>
                        <td>{banco.codigo}</td>
                        <td className="text-nowrap">{banco.nome}</td>
                        <td className="text-center">
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-custom-secondary btn-sm"
                              onClick={() => handleEditBanco(banco)}
                              title="Editar"
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn btn-custom-secondary btn-sm ms-3"
                              onClick={() => handleDeleteBanco(banco)}
                              title="Excluir"
                            >
                              <FaTrashAlt />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <BancoModal
          banco={selectedBanco}
          onClose={handleModalClose}
          onBancoAtualizado={handleBancoAtualizado}
        />
      )}
    </div>
  );
};

export default Bancos; 